import { render, staticRenderFns } from "./menuDesignRight.vue?vue&type=template&id=8086eea4"
import script from "./menuDesignRight.vue?vue&type=script&lang=js"
export * from "./menuDesignRight.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports